
<div >
  <breadcrumbs>
    <breadcrumb route="/" [label]="'Dashboard' | translate | async"></breadcrumb>
    <breadcrumb [currentRoute]="true" [label]="'Component Life Performance' | translate | async"></breadcrumb>
  </breadcrumbs>
  
</div>

<div class="page-padding">
  <div class="pannel">
   
  <div class="panel panel--search" *ngIf="!show">
    <div class="panel__header">
        <a class="button button--primary" style="margin-bottom: 16px;" (click)="searchIsVisible(true)">
            <i class="material-icons button__icon">&#xE8B6;</i>
            <span class="button__text">{{'Search' | translate | async}}</span>
        </a>
       
    </div>
  </div>
<div class ="panel panel--search" *ngIf="show"[@enterAnimation]>
  <div class="panel__header" >
  <div class ="header__title-container" matTooltip="Hide Search" (click)="searchIsVisible(false)">
    <i class="material-icons title-container__close">close</i>
    <span class="panel__header__title">{{'Search'  | translate | async}}</span>
 </div>
 </div>

    <mat-card class = "panel_search mat-card" >

    <form class="header-form">
   

      <mat-form-field class="header-form-full-width">
        <mat-select placeholder="{{'Dealer Name' | translate | async}}" name="dealerID" [(ngModel)]="dealerID" required>
          <mat-option value="0"> </mat-option>
          <mat-option [value]="type.DealershipId" *ngFor="let type of dealerList">
            {{type.DealershipName}}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field class="header-form-full-width">
        <mat-select (selectionChange)="makeChanged($event)" [(value)]="selectedMake" name="make" placeholder="{{'Select Make' | translate | async}}" [(ngModel)]="selectedMakeValue" required>
          <mat-option>None</mat-option>
          <mat-option *ngFor="let make of _dropDownLists.makeList" [value]="make.Id">
            {{ make.Title }}
          </mat-option>
        </mat-select>
      </mat-form-field>

      
      <mat-form-field class="header-form-full-width">
        <mat-select placeholder="{{'Serial No.' | translate | async}}" name="serialno" [(value)]="EquipmentId" [(ngModel)]="EquipmentId" multiple>
            <mat-option value="0"> </mat-option>
           <mat-option [value]="type.EquipmentId" *ngFor="let type of equipmnentList" multiple> 
           {{ type.SerialNo }}
          </mat-option>
        </mat-select>
      </mat-form-field>


       
        <mat-form-field class="header-form-full-width">
          <mat-select (selectionChange)="customerChanged($event)" name="customer" placeholder="{{'Select Customer' | translate | async}}" [(ngModel)]="selectedCustomerValue" required >
            <mat-option *ngFor="let customer of CustomerList" [value]="customer.Id">
              {{ customer.Title }}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field class="header-form-full-width">
          <mat-select placeholder="{{'Family' | translate | async}}"  name="typeid" [(value)]="typeid" [(ngModel)]="typeid" (selectionChange)="FamilyChanged()" required>
              <mat-option value="0"> </mat-option>
            <mat-option [value]="type.Id" *ngFor="let type of _fleetService.familyList"> 
              {{type.Title + ' | ' + type.Symbol}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      
        
        <mat-form-field class="header-form-full-width">
          <mat-select placeholder="{{'Unit No.' | translate | async}}" name="serialno" [(ngModel)]="selectedEquipments" [(value)]="EquipmentId" multiple>
              <mat-option value="0"> </mat-option>
            <mat-option [value]="type.EquipmentId" *ngFor="let type of equipmnentList" multiple> 
             {{  type.UnitNo}}
            </mat-option>
          </mat-select>
        </mat-form-field>

        


        <mat-form-field class="header-form-full-width">
          <mat-select (selectionChange)="jobsiteChanged($event)"  name="jobsite" placeholder="{{'Select Job Site' | translate | async}}" [(ngModel)]="selectedJobsite" required >
            <mat-option *ngFor="let jobsite of _dropDownListsFiltered.jobSiteList" [value]="jobsite.Id">
              {{ jobsite.Title }}
            </mat-option>
          </mat-select>
        </mat-form-field>


       
   
          <mat-form-field class="header-form-full-width"  >
            <mat-select placeholder="{{'Model' | translate | async}}" name="modelID_" [(ngModel)]="selectModelValue" required>
                <mat-option value="0"> </mat-option>
               <mat-option [value]="type.Id" *ngFor="let type of _componentService.availableModelList">
                <!-- <mat-option [value]="type" *ngFor="let type of _componentService.availableModelList"> -->
                {{type.Title}}
              </mat-option>
            </mat-select>
          </mat-form-field>
          

          <mat-form-field class="header-form-full-width invisible"  >
            <mat-select name="modelID_" [(ngModel)]="selectModelValue" class="invisible" >
          </mat-select>
          </mat-form-field>


        
  
</form>


 

</mat-card>

<mat-card class = "panel_search mat-card">
  <div style="text-align:left;">
   
    <h3 style="color: blue;">
    <span class="" >{{'Filter by Component Details' | translate | async}}</span>
  </h3>
  </div>
  <form class="header-form">
  

  
    
      <mat-form-field class="header-form-full-width">
        <mat-select  name="jobstype_" placeholder="{{'Jobsite Type'| translate | async}}" [(ngModel)]="selectedJobsiteType" multiple>
          <!-- <mat-option *ngFor="let jobtype of jobsitetypesList" [value]="jobtype.ID"> -->
            <mat-option *ngFor="let jobtype of jobsitetypesList" [value]="jobtype.ID">
            {{ jobtype.Name }}
          </mat-option>
        </mat-select>
      </mat-form-field>


      <mat-form-field class="header-form-full-width">
        <mat-select (selectionChange)="makeChanged($event)" [(value)]="selectedMakeValue" name="make" placeholder="{{'Brand'| translate | async}}" [(ngModel)]= "selectedMakeValue">
          <mat-option>None</mat-option>
          <mat-option *ngFor="let make of _dropDownLists.makeList" [value]="make.Id">
            {{ make.Title }}
          </mat-option>
        </mat-select>
      </mat-form-field>
  
      <mat-form-field class="header-form-full-width">
        <input matInput [matDatepicker]="startDatePicker" placeholder="{{'Start Date'| translate | async}}" [(ngModel)]="startDate"
          [ngModelOptions]="{standalone: true}">
        <mat-datepicker-toggle matSuffix [for]="startDatePicker"></mat-datepicker-toggle>
        <mat-datepicker #startDatePicker></mat-datepicker>
      </mat-form-field>
      

     

      <mat-form-field class="header-form-full-width">
        <mat-select placeholder="{{'Component Type'| translate | async}}" name="componenttype_" [(ngModel)]="selectedCompType" (selectionChange)="changeCompType()" multiple>
            <mat-option value="0"> </mat-option>
          <mat-option [value]="componenttype.comTypeAuto" *ngFor="let componenttype of componenttypesList" multiple>
           {{ componenttype.comTypeName }}
          </mat-option>
        </mat-select>
      </mat-form-field>


      <mat-form-field class="header-form-full-width">
        <mat-select placeholder="{{'Side'| translate | async}}"  name="side"[(ngModel)]="selectedSide">
          <mat-option value="0">Default </mat-option> 
          <mat-option value="1">Left </mat-option>
            <mat-option value="2"> Right</mat-option>
     </mat-select>
      </mat-form-field>


      <mat-form-field class="header-form-full-width">
        <input matInput [matDatepicker]="endDatePicker" placeholder="{{'End Date'| translate | async}}" [(ngModel)]="enddate" 
          [ngModelOptions]="{standalone: true}">
        <mat-datepicker-toggle matSuffix [for]="endDatePicker"></mat-datepicker-toggle>
        <mat-datepicker #endDatePicker ></mat-datepicker>
      </mat-form-field>

     

      <mat-form-field class="header-form-full-width">
        <mat-select placeholder="{{'Component'| translate | async}}" name="comtype_" [(ngModel)]="selectedComp" multiple>
          <mat-option [value]="0"></mat-option>
            <mat-option *ngFor="let comtype of componentList" [value]="comtype.compartIdAuto">
            {{ comtype.comName}} , {{comtype.compart_note}}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field class="header-form-full-width invisible"  >
        <mat-select name="modelID_" [(ngModel)]="selectModelValue" class="invisible" >
      </mat-select>
      </mat-form-field>
      <mat-form-field class="header-form-full-width invisible"  >
        <mat-select name="modelID_" [(ngModel)]="selectModelValue" class="invisible" >
      </mat-select>
      </mat-form-field>
<!-- Upper Limit and Lower Limit for Graphs -->




    
      <p>

      </p>

      <section class="example-section">
        <mat-checkbox (change) = "checkboxChanged($event)" class="example-margin">{{'Only components currently fitted to equipment'| translate | async}} </mat-checkbox>  
        
      </section>

      <div class="search-options-cell" style="display: flex; margin-right: 35%;justify-content: space-between; column-gap: 20px">
        <div class="input-container addsapce" style="   margin-left: -6%;margin-top: -1%;">
            <span class="label" style="    margin-left: 30%;">{{'Show/Hide'| translate | async}}</span>
        </div>

        <mat-checkbox  class="example-margin" [(ngModel)]="Customer" name="Customer_"(change)="changeCheckbox(Customer, 'customerName',0 )">{{'Customer' | translate | async}}</mat-checkbox>
        <mat-checkbox class="example-margin" [(ngModel)]="Jobsite" name="Jobsite_"(change)="changeCheckbox(Jobsite, 'jobSiteName',1 )"> {{'Jobsite' | translate | async}}</mat-checkbox>
        <mat-checkbox class="example-margin" [(ngModel)]="UnitNo"name="UnitNo_" (change)="changeCheckbox(UnitNo, 'unitNo',5 )">{{'Unit No'| translate | async}}</mat-checkbox>
        <mat-checkbox class="example-margin" [(ngModel)]="Make"name="Make_" (change)="changeCheckbox(Make, 'brandName',2 )">  {{'Make'| translate | async}}</mat-checkbox>
        <mat-checkbox class="example-margin" [(ngModel)]="Family" name="Family_"(change)="changeCheckbox(Family, 'family',3 )"> {{'Family'| translate | async}}</mat-checkbox>

        <!-- <mat-checkbox class="example-margin" [(ngModel)]="Model" (change)="changeCheckbox(Model, 'model' ,7)">Model
        </mat-checkbox> -->



    </div>

      
     
   <div class="bottom-row"> 
    <section class="bottom-row__left" >
    <!-- <a class="button button--primary"><i class="material-icons button__icon"></i><span class="button__text"
        (click)="showPerformanceTable(); submitSelection()">{{'Search'}}</span></a>
        <a class="button"><span class="button__text"  (click)="resetFields()">{{'Reset'}}</span></a> -->
    </section>
        <div class="flex flex--align-center">
          <a class="button" ><span class="button__text" (click)="resetFields()">{{'Reset'| translate | async}}</span></a>
          <a class="button button--primary"><i class="material-icons button__icon">search</i><span

                  class="button__text" (click)="showPerformanceTable(); submitSelection();loadGraphData()">{{'Search'| translate | async}}</span></a>

          <a class="button button--primary"><i class="material-icons button__icon"></i><span class="button__text"
      (click)="DownloadCSVFile()">
  {{'Export to Excel' | translate | async}}
</span></a> 
      </div>

  </div>




</form>


</mat-card>
</div>

<p>

</p>
<div>
<mat-tab-group animationDuration="0ms">
  <mat-tab label="{{'Component Performance Details' | translate | async}}">

<div class="center" *ngIf="showloading">
  <mat-spinner></mat-spinner>
</div>
<mat-card class = "panel_search mat-card" *ngIf="!showloading">


  <div style="text-align:center; font-weight: bold;"> 
    <span class="" >{{'Averages'| translate | async}}:</span>
  </div>
  <p>

  </p>

  <div style="text-align:center; font-weight: bold;"> 
    <!-- <span class="" >Average Life | Average Normalized to 100% |Average Normalized to 120% |Average Cost per Hour </span> -->
    
    <span class="">{{'Average Life:'| translate | async}} </span>&nbsp;{{averageLife()}}
    
    &nbsp;&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;&nbsp;<span class=""> {{'Average Projected to 100%'| translate | async}}: </span>&nbsp; {{averageNormalized()}}
    &nbsp;&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;&nbsp; <span class="" >{{'Average Projected to 120%'| translate | async}}: </span>&nbsp;{{ averageNormalized120() }}
    &nbsp;&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;&nbsp;<span class="" >{{'Average Cost per Hour'| translate | async}}: </span>&nbsp;{{averageCostperHour()}}
  </div>  
  
</mat-card>

<div>
<mat-card>
  <div *ngIf="noRecords"
        style="display: block;margin-left: 41%;font-size: larger;font-weight: bolder;">
        <span style="color: red; font-style: italic;">No Data Found - please can reset your selection and try again.</span>
    </div>
  <mat-table [dataSource]="dataSource" matSort class="mat-elevation-z8"style=" margin: 5px; "  >
    <!-- Position Column -->
    <ng-container matColumnDef="customerName">
      <mat-header-cell  *matHeaderCellDef mat-sort-header>{{'Customer'| translate | async}}</mat-header-cell>
      <mat-cell *matCellDef="let element" title="{{element.customerName}}"><div class="SerialAndUnitText">{{element.customerName}}</div></mat-cell>
    </ng-container>
  
    <!-- Name Column -->
    <ng-container matColumnDef="jobSiteName"  >
      <mat-header-cell *matHeaderCellDef mat-sort-header>{{'Job Site'| translate | async}}</mat-header-cell>
      <mat-cell *matCellDef="let element" title="{{element.jobSiteName}}"><div class="SerialAndUnitText">{{element.jobSiteName}}</div></mat-cell>
    </ng-container>
  
    <!-- Weight Column -->
    <ng-container matColumnDef="brandName">
      <mat-header-cell *matHeaderCellDef mat-sort-header>{{'Make'| translate | async}}</mat-header-cell>
      <mat-cell *matCellDef="let element" title="{{element.brandName}}"><div class="SerialAndUnitText">{{element.brandName}}</div></mat-cell>
    </ng-container>
  

    <ng-container matColumnDef="family">
      <mat-header-cell   *matHeaderCellDef mat-sort-header>{{'Family'| translate | async}}</mat-header-cell>
      <mat-cell *matCellDef="let element" title="{{element.FamilyName}}"><div class="SerialAndUnitText">{{element.FamilyName}}</div></mat-cell>
    </ng-container>  

    
    
    <ng-container matColumnDef="model">
      <mat-header-cell *matHeaderCellDef mat-sort-header>{{'Model'| translate | async}}</mat-header-cell>
      <mat-cell *matCellDef="let element" title="{{element.modelName}}"><div class="SerialAndUnitText">{{element.modelName}}</div></mat-cell>
    </ng-container>

    <!-- Symbol Column -->
    <ng-container matColumnDef="unitNo">
      <mat-header-cell *matHeaderCellDef mat-sort-header>{{'Unit No'| translate | async}}</mat-header-cell>
      <mat-cell *matCellDef="let element" title="{{element.unitNo}}"><div class="SerialAndUnitText">{{element.unitNo}}</div></mat-cell>
    </ng-container>
  
    <!-- Symbol Column -->
    <!-- <ng-container matColumnDef="unitNo">
      <mat-header-cell *matHeaderCellDef mat-sort-header>Unit No</mat-header-cell>
      <mat-cell *matCellDef="let element"><div class="SerialAndUnitText">{{element.unitNo}}</div></mat-cell>
    </ng-container> -->

    <!-- <ng-container matColumnDef="system">
      <mat-header-cell *matHeaderCellDef mat-sort-header>System</mat-header-cell>
      
      <mat-cell *matCellDef="let element"><div class="SerialAndUnitText">{{element.systypeName}}</div></mat-cell>
    
    </ng-container> -->

    <ng-container matColumnDef="ComponentType">
      <mat-header-cell *matHeaderCellDef mat-sort-header>{{'Component Type'| translate | async}}</mat-header-cell>
      <mat-cell style ="text-align: center" *matCellDef="let element" title="{{element.ComponentType}}"><div class="SerialAndUnitText">{{element.ComponentType}}</div></mat-cell>
    </ng-container>

    <ng-container matColumnDef="componentName">
      <mat-header-cell *matHeaderCellDef mat-sort-header>{{'Component'| translate | async}}</mat-header-cell>
      <mat-cell *matCellDef="let element" title="{{element.componentName}}"><div class="SerialAndUnitText">{{element.componentName}}</div></mat-cell>
    </ng-container>

    <ng-container matColumnDef="part">
      <mat-header-cell *matHeaderCellDef mat-sort-header>{{'Part'| translate | async}}</mat-header-cell>
      <mat-cell *matCellDef="let element" title="{{element.part}}"><div class="SerialAndUnitText">{{element.part}}</div></mat-cell>
    </ng-container>


    <ng-container matColumnDef="side">
      <mat-header-cell *matHeaderCellDef mat-sort-header>{{'Side'| translate | async}}</mat-header-cell>
      
      <mat-cell *matCellDef="let element" title="{{element.side==1?'Left':'Right'}}"><div class="SerialAndUnitText">{{element.side==1?'Left':'Right'}}</div></mat-cell>
    </ng-container>

    <ng-container matColumnDef="hoursOnSurface">
      <mat-header-cell *matHeaderCellDef mat-sort-header>{{'CMU'| translate | async}}</mat-header-cell>
      <mat-cell *matCellDef="let element" title="{{element.hoursOnSurface}}"><div class="SerialAndUnitText">{{element.hoursOnSurface}}</div></mat-cell>
    </ng-container>

    <ng-container matColumnDef="worn">
      <mat-header-cell *matHeaderCellDef mat-sort-header>{{'Last Worn%'| translate | async}}</mat-header-cell>
      <mat-cell  *matCellDef="let element" title="{{element.worn.toFixed(1)}}"><div class="SerialAndUnitText" style="text-align: center;">{{element.worn.toFixed(1)}}</div></mat-cell>
    </ng-container>

    <ng-container matColumnDef="evalCode">
      <mat-header-cell *matHeaderCellDef mat-sort-header>{{'Last Eval'| translate | async}}</mat-header-cell>
      <mat-cell *matCellDef="let element" title="{{element.evalCode}}"><div class="SerialAndUnitText">{{element.evalCode}}</div></mat-cell>
    </ng-container>

    <ng-container matColumnDef="Cost">
      <mat-header-cell *matHeaderCellDef mat-sort-header>{{'Cost'| translate | async}}</mat-header-cell>
      <mat-cell  *matCellDef="let element" title="{{element.Cost}}"><div class="SerialAndUnitText">{{element.Cost}}</div></mat-cell>
    </ng-container>

   
    <ng-container matColumnDef="startDate">
      <mat-header-cell *matHeaderCellDef mat-sort-header>{{'Start Date'| translate | async}}</mat-header-cell>
      <mat-cell *matCellDef="let element" title="{{element.startDate}}"><div class="SerialAndUnitText">{{element.startDate}}</div></mat-cell> 
      <!-- <mat-cell *matCellDef="let element">{{ element.startDate == ""? '' :  element.startDate | date:'dd-MMM-yyyy'}}</mat-cell>  -->
    
    </ng-container>

    

    <ng-container matColumnDef="normalize100">
      <mat-header-cell *matHeaderCellDef mat-sort-header>{{'Projected 100% Hrs'| translate | async}}</mat-header-cell> 
      <mat-cell style ="text-align: center" *matCellDef="let element" title="{{element.normalize100| number}}"><div class="SerialAndUnitText">{{element.normalize100| number}}</div></mat-cell>   
    </ng-container>


    <ng-container matColumnDef="normalize120">
      <mat-header-cell *matHeaderCellDef mat-sort-header>{{'Projected 120% Hrs'| translate | async}}</mat-header-cell>
      <mat-cell style="text-align: center;" *matCellDef="let element" title="{{element.normalize120 |number}}"><div class="SerialAndUnitText">{{element.normalize120 |number}}</div></mat-cell>
    </ng-container>


   <ng-container matColumnDef="dateRemoved">
      <mat-header-cell *matHeaderCellDef mat-sort-header>{{'Date Removed'| translate | async}}</mat-header-cell>
      <mat-cell *matCellDef="let element" title="{{element.endDate| date : 'dd-MMM-yyyy'}}"><div class="SerialAndUnitText">{{element.endDate| date : 'dd-MMM-yyyy'}}</div></mat-cell>
    </ng-container>

   
    <ng-container matColumnDef="costPerhour">
      <mat-header-cell *matHeaderCellDef mat-sort-header>{{'Cost Per Hour'| translate | async}}</mat-header-cell>    
      <mat-cell style ="text-align: center"  *matCellDef="let element" title="{{element.Cost >0 ? ((element.Cost/element.normalize100)=='Infinity'? 0:(element.Cost/element.normalize100).toFixed(1)):0}}"><div class="SerialAndUnitText">{{element.Cost >0 ? ((element.Cost/element.normalize100)=='Infinity'? 0:(element.Cost/element.normalize100).toFixed(1)):0}}</div></mat-cell>
    </ng-container>

    <ng-container matColumnDef="select">
      <mat-header-cell *matHeaderCellDef>
        <mat-checkbox (change)="$event ? masterToggle() : null"
                      [checked]="selection.hasValue() && isAllSelected()"
                      [indeterminate]="selection.hasValue() && !isAllSelected()">
        </mat-checkbox>{{'AVG'| translate | async}}
      </mat-header-cell>
      <mat-cell *matCellDef="let row">
        <mat-checkbox (change) = "checkboxChangedCount($event)"
                      (click)="$event.stopPropagation()"
                      (change)="$event ? selection.toggle(row) : null"
                      [checked]="selection.isSelected(row)">
        </mat-checkbox>
      </mat-cell>
    </ng-container>
        
    <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
    <mat-row *matRowDef="let row; columns: displayedColumns;" (click)="OpenActionHistroy(row)" style="cursor: pointer;"></mat-row>
  </mat-table>

  <mat-paginator [pageSizeOptions]="[50, 100, 200]" showFirstLastButtons></mat-paginator>
</mat-card>
</div>
</mat-tab>

  </mat-tab-group>
</div>

</div>
</div>




